import { Idioma } from './../../domain/Idioma';
import { Injectable } from '@angular/core';
import { EspacioIdiomaFormulario } from '../../domain/EspacioFormulario';
import { NivelIdiomaFormulario } from '../../domain/NivelFormulario';
import { AlaIdiomaFormulario } from '../../domain/AlaFormulario';
import { NoticiaIdiomaFormulario } from '../../domain/Noticia';
import { RutaSugeridaIdiomaFormulario } from '../../domain/RutaSugerida';
import { PerfilIdiomaFormulario } from '../../domain/PerfilFormulario';
import { TipologiaContenidoIdiomaFormulario } from '../../domain/TipologiaContenidoFormulario';
import { TipologiaSeccionIdiomaFormulario } from '../../domain/TipologiaSeccionFormulario';
import { SeccionIdiomaFormulario } from '../../domain/SeccionFormulario';
import { NodoIdiomaFormulario } from '../../domain/NodoFormulario';
import { ConexionNodoIdiomaFormulario } from '../../domain/ConexionFormulario';
import { ContenidoIdiomaFormulario, Contenido } from '../../domain/Contenido';
import { ContenidoWebExternaIdiomaFormulario } from '../../domain/WebExterna';
import { TranslateService } from 'ng2-translate';


@Injectable()
export class IdiomaService {

	constructor(
		private translate: TranslateService,
	){

	}

	public getIdiomaDefecto(idiomas: Idioma[]): Idioma{
		const idiomaDefecto = idiomas.filter( x => x.ENTIDAD.Default)[0];
		return idiomaDefecto;
	}

	/* ESPACIO */
	public newMapEspacioIdiomas(idiomas){

		const espacioIdiomas = new Map<string, EspacioIdiomaFormulario>();

		idiomas.forEach(element => {
			const espacioIdioma = new EspacioIdiomaFormulario();
			espacioIdiomas.set(element.value, espacioIdioma);
		});

		return espacioIdiomas;
	}

	public getMapEspacioIdiomas(ESPACIO_IDIOMAs: any[]){

		const espacioIdiomas = new Map<string, EspacioIdiomaFormulario>();

		ESPACIO_IDIOMAs.forEach(ESPACIO_IDIOMA => {
			const espacioIdioma = new EspacioIdiomaFormulario(ESPACIO_IDIOMA);
			espacioIdiomas.set(espacioIdioma.Codigo, espacioIdioma);
		});

		return espacioIdiomas;
	}

	/* NIVEL */
	public newMapNivelIdiomas(idiomas){

		const nivelIdiomas = new Map<string, NivelIdiomaFormulario>();

		idiomas.forEach(element => {
			const nivelIdioma = new NivelIdiomaFormulario();
			nivelIdiomas.set(element.value, nivelIdioma);
		});

		return nivelIdiomas;
	}

	public getMapNivelIdiomas(NIVEL_IDIOMAs: any[]){

		const nivelIdiomas = new Map<string, NivelIdiomaFormulario>();

		NIVEL_IDIOMAs.forEach(NIVEL_IDIOMA => {
			const nivelIdioma = new NivelIdiomaFormulario(NIVEL_IDIOMA);
			nivelIdiomas.set(nivelIdioma.Codigo, nivelIdioma);
		});

		return nivelIdiomas;
	}


	/* ALA */
	public newMapAlaIdiomas(idiomas){

		const alaIdiomas = new Map<string, AlaIdiomaFormulario>();

		idiomas.forEach(element => {
			const alaIdioma = new AlaIdiomaFormulario();
			alaIdiomas.set(element.value, alaIdioma);
		});

		return alaIdiomas;
	}

	public getMapAlaIdiomas(ALA_IDIOMAs: any[]){

		const alaIdiomas = new Map<string, AlaIdiomaFormulario>();

		ALA_IDIOMAs.forEach(ALA_IDIOMA => {
			const alaIdioma = new AlaIdiomaFormulario(ALA_IDIOMA);
			alaIdiomas.set(alaIdioma.Codigo, alaIdioma);
		});

		return alaIdiomas;
	}

	/* NOTICIA */
	public newMapNoticiaIdiomas(idiomas){

		const noticiaIdiomas = new Map<string, NoticiaIdiomaFormulario>();

		idiomas.forEach(element => {
			const noticiaIdioma = new NoticiaIdiomaFormulario();
			noticiaIdiomas.set(element.value, noticiaIdioma);
		});

		return noticiaIdiomas;
	}

	public getMapNoticiaIdiomas(NOTICIA_IDIOMAs: any[]){

		const noticiaIdiomas = new Map<string, NoticiaIdiomaFormulario>();

		NOTICIA_IDIOMAs.forEach(NOTICIA_IDIOMA => {
			const noticiaIdioma = new NoticiaIdiomaFormulario(NOTICIA_IDIOMA);
			noticiaIdiomas.set(noticiaIdioma.Codigo, noticiaIdioma);
		});

		return noticiaIdiomas;
	}

	/* RUTA_SUGERIDA */
	public newMapRutaSugeridaIdiomas(idiomas){

		const noticiaIdiomas = new Map<string, RutaSugeridaIdiomaFormulario>();

		idiomas.forEach(element => {
			const noticiaIdioma = new RutaSugeridaIdiomaFormulario();
			noticiaIdiomas.set(element.value, noticiaIdioma);
		});

		return noticiaIdiomas;
	}

	public getMapRutaSugeridaIdiomas(RUTA_SUGERIDA_IDIOMAs: any[]){

		const noticiaIdiomas = new Map<string, RutaSugeridaIdiomaFormulario>();

		RUTA_SUGERIDA_IDIOMAs.forEach(RUTA_SUGERIDA_IDIOMA => {
			const noticiaIdioma = new RutaSugeridaIdiomaFormulario(RUTA_SUGERIDA_IDIOMA);
			noticiaIdiomas.set(noticiaIdioma.Codigo, noticiaIdioma);
		});

		return noticiaIdiomas;
	}

		/* PERFIL_MOVILIDAD */

		public newMapPerfilmovilidadIdiomas(idiomas){

			const perfilIdiomas = new Map<string, PerfilIdiomaFormulario>();

			idiomas.forEach(element => {
				const perfilIdioma = new PerfilIdiomaFormulario();
				perfilIdiomas.set(element.value, perfilIdioma);
			});

			return perfilIdiomas;
		}

		public getMapPerfilmovilidadIdiomas(PERFIL_MOVILIDAD_IDIOMAs: any[]){

			const perfilIdiomas = new Map<string, PerfilIdiomaFormulario>();

			PERFIL_MOVILIDAD_IDIOMAs.forEach(PERFIL_MOVILIDAD_IDIOMA => {
				const rutaSugeridaIdioma = new PerfilIdiomaFormulario(PERFIL_MOVILIDAD_IDIOMA);
				perfilIdiomas.set(rutaSugeridaIdioma.Codigo, rutaSugeridaIdioma);
			});

			return perfilIdiomas;
		}


	/* TIPOLOGIA_CONTENIDO */

	public newMapTipologiaContenidoIdiomas(idiomas){

		const tipologiaContenidoIdiomas = new Map<string, TipologiaContenidoIdiomaFormulario>();

		idiomas.forEach(element => {
			const tipologiaContenidoIdioma = new TipologiaContenidoIdiomaFormulario();
			tipologiaContenidoIdiomas.set(element.value, tipologiaContenidoIdioma);
		});

		return tipologiaContenidoIdiomas;
	}

	public getMapTipologiaContenidoIdiomas(TIPOLOGIA_CONTENIDO_IDIOMAs: any[]){

		const tipologiaContenidoIdiomas = new Map<string, TipologiaContenidoIdiomaFormulario>();

		TIPOLOGIA_CONTENIDO_IDIOMAs.forEach(TIPOLOGIA_CONTENIDO_IDIOMA => {
			const tipologiaContenidoIdioma = new TipologiaContenidoIdiomaFormulario(TIPOLOGIA_CONTENIDO_IDIOMA);
			tipologiaContenidoIdiomas.set(tipologiaContenidoIdioma.Codigo, tipologiaContenidoIdioma);
		});

		return tipologiaContenidoIdiomas;
	}

	public traducirTipologiasContenidoIdiomaNavegador(tipologias): any[]
	{
		const codigoIdioma = this.translate.currentLang;
		const tipologiasTraducidas = this.traducirTipologiasContenido(tipologias, {value: codigoIdioma});
		return tipologiasTraducidas;
	}

	public traducirTipologiasContenido(tipologias, idioma): any[]{
		const aux = [];
		tipologias.forEach(t => {
			const tipologia = this.traducirTipologiaContenido(t, idioma);
			if (tipologia) {
				aux.push(tipologia);
			}
		});
		return aux;
	}

	public traducirTipologiaContenido(tipologia: any, idioma: any): any {
		if (tipologia.IDIOMAS) {
			tipologia.Idiomas = this.getMapTipologiaContenidoIdiomas(tipologia.IDIOMAS);
			const contenidoIdioma = tipologia.Idiomas.get(idioma.value);
			tipologia.Nombre = contenidoIdioma.Nombre;
		}

		return tipologia.Nombre !== '' ? tipologia : undefined;
	}

	/* TIPOLOGIA_SECCION */

	public newMapTipologiaSeccionIdiomas(idiomas){

		const tipologiaSeccionIdiomas = new Map<string, TipologiaSeccionIdiomaFormulario>();

		idiomas.forEach(element => {
			const tipologiaContenidoIdioma = new TipologiaSeccionIdiomaFormulario();
			tipologiaSeccionIdiomas.set(element.value, tipologiaContenidoIdioma);
		});

		return tipologiaSeccionIdiomas;
	}

	public getMapTipologiaSeccionIdiomas(TIPOLOGIA_SECCION_IDIOMAs: any[]){

		const tipologiaSeccionIdiomas = new Map<string, TipologiaSeccionIdiomaFormulario>();

		TIPOLOGIA_SECCION_IDIOMAs.forEach(TIPOLOGIA_SECCION_IDIOMA => {
			const tipologiaSeccionIdioma = new TipologiaSeccionIdiomaFormulario(TIPOLOGIA_SECCION_IDIOMA);
			tipologiaSeccionIdiomas.set(tipologiaSeccionIdioma.Codigo, tipologiaSeccionIdioma);
		});

		return tipologiaSeccionIdiomas;
	}

	public traducirTipologiasSeccionIdiomaNavegador(tipologiasSeccion): any[]
	{
		const codigoIdioma = this.translate.currentLang;
		const tipologiasSeccionTraducidas = this.traducirTipologiasSeccion(tipologiasSeccion, {value: codigoIdioma});
		return tipologiasSeccionTraducidas;
	}

	public traducirTipologiasSeccion(tipologiasSeccion, idioma): any[]{
		const aux = [];
		tipologiasSeccion.forEach(t => {
			const tipologiaSeccion = this.traducirTipologiaSeccion(t, idioma);
			if (tipologiaSeccion) {
				aux.push(tipologiaSeccion);
			}
		});
		return aux;
	}

	public traducirTipologiaSeccion(tipologiaSeccion: any, idioma: any): any {
		if (tipologiaSeccion.IDIOMAS) {
			tipologiaSeccion.Idiomas = this.getMapTipologiaSeccionIdiomas(tipologiaSeccion.IDIOMAS);
			const contenidoIdioma = tipologiaSeccion.Idiomas.get(idioma.value);
			tipologiaSeccion.Nombre = contenidoIdioma.Nombre;
		}

		return tipologiaSeccion.Nombre !== '' ? tipologiaSeccion : undefined;
	}


	/* SECCION */

	public newMapSeccionIdiomas(idiomas){

		const seccionIdiomas = new Map<string, SeccionIdiomaFormulario>();

		idiomas.forEach(element => {
			const seccionIdioma = new SeccionIdiomaFormulario();
			seccionIdiomas.set(element.value, seccionIdioma);
		});

		return seccionIdiomas;
	}

	public getMapSeccionIdiomas(SECCION_IDIOMAs: any[]){

		const seccionIdiomas = new Map<string, SeccionIdiomaFormulario>();

		SECCION_IDIOMAs.forEach(SECCION_IDIOMA => {
			const seccionIdioma = new SeccionIdiomaFormulario(SECCION_IDIOMA);
			seccionIdiomas.set(seccionIdioma.Codigo, seccionIdioma);
		});

		return seccionIdiomas;
	}
	/* NODO */

	public newMapNodoIdiomas(idiomas){

		const nodoIdiomas = new Map<string, NodoIdiomaFormulario>();

		idiomas.forEach(element => {
			const nodoIdioma = new NodoIdiomaFormulario();
			nodoIdiomas.set(element.value, nodoIdioma);
		});

		return nodoIdiomas;
	}

	public getMapNodoIdiomas(NODO_IDIOMAs: any[]){

		const nodoIdiomas = new Map<string, NodoIdiomaFormulario>();

		NODO_IDIOMAs.forEach(NODO_IDIOMA => {
			const nodoIdioma = new NodoIdiomaFormulario(NODO_IDIOMA);
			nodoIdiomas.set(nodoIdioma.Codigo, nodoIdioma);
		});

		return nodoIdiomas;
	}


	public newMapConexionNodoIdiomas(idiomas){

		const conexionNodoIdiomas = new Map<string, ConexionNodoIdiomaFormulario>();

		idiomas.forEach(element => {
			const conexionNodoIdioma = new ConexionNodoIdiomaFormulario();
			conexionNodoIdiomas.set(element.value, conexionNodoIdioma);
		});

		return conexionNodoIdiomas;
	}

	public getMapConexionNodoIdiomas(CONEXION_NODOS_IDIOMAs: any[]){

		const conexionNodoIdiomas = new Map<string, ConexionNodoIdiomaFormulario>();

		CONEXION_NODOS_IDIOMAs.forEach(CONEXION_NODOS_IDIOMA => {
			const conexionNodoIdioma = new ConexionNodoIdiomaFormulario(CONEXION_NODOS_IDIOMA);
			conexionNodoIdiomas.set(conexionNodoIdioma.Codigo, conexionNodoIdioma);
		});

		return conexionNodoIdiomas;
	}

	public newMapContenidoIdiomas(idiomas){

		const contenidoIdiomas = new Map<string, ContenidoIdiomaFormulario>();

		idiomas.forEach(element => {
			const contenidoIdioma = new ContenidoIdiomaFormulario();
			contenidoIdiomas.set(element.value, contenidoIdioma);
		});

		return contenidoIdiomas;
	}

	public getMapContenidoIdiomas(CONTENIDO_IDIOMAs: any[]){

		const contenidoIdiomas = new Map<string, ContenidoIdiomaFormulario>();

		CONTENIDO_IDIOMAs.forEach(CONTENIDO_IDIOMA => {
			const contenidoIdioma = new ContenidoIdiomaFormulario(CONTENIDO_IDIOMA);
			contenidoIdiomas.set(contenidoIdioma.Codigo, contenidoIdioma);
		});

		return contenidoIdiomas;
	}

	/* CONTENIDO_WEB_EXTERNA */
	public newMapContenidoWebExternaIdiomas(idiomas){

		const contenidoWebExternaIdiomas = new Map<string, ContenidoWebExternaIdiomaFormulario>();

		idiomas.forEach(element => {
			const contenidoWebExternaIdioma = new ContenidoWebExternaIdiomaFormulario();
			contenidoWebExternaIdiomas.set(element.value, contenidoWebExternaIdioma);
		});

		return contenidoWebExternaIdiomas;
	}

	public getMapContenidoWebExternaIdiomas(CONTENIDO_WEB_EXTERNA_IDIOMAs: any[]){

		const contenidoWebExternaIdiomas = new Map<string, ContenidoWebExternaIdiomaFormulario>();

		CONTENIDO_WEB_EXTERNA_IDIOMAs.forEach(CONTENIDO_WEB_EXTERNA_IDIOMA => {
			const contenidoWebExternaIdioma = new ContenidoWebExternaIdiomaFormulario(CONTENIDO_WEB_EXTERNA_IDIOMA);
			contenidoWebExternaIdiomas.set(contenidoWebExternaIdioma.Codigo, contenidoWebExternaIdioma);
		});

		return contenidoWebExternaIdiomas;
	}

	/* FECHAS */
	public timastampToDate(timestamp){
		// unixtimestamp = 201810111320290260
		// Months array

		// Convert timestamp to milliseconds
		const date = new Date();

		// Year
		const year = timestamp.slice(0, 4);

		// Month
		const month = timestamp.slice(4, 6) - 1;

		// Day
		const day = timestamp.slice(6, 8);

		date.setFullYear(year, month, day);

		// Hours
		const hours = timestamp.slice(8, 10);

		// Minutes
		const minutes = timestamp.slice(10, 12);

		// Seconds
		const seconds = timestamp.slice(12, 14);

		date.setHours(hours, minutes, seconds);

		return date;
	}

	public unixtimestampToDate(unixtimestamp){

		// Convert timestamp to milliseconds
		const date = new Date(unixtimestamp * 1000);

		return date;

	}

	/* CONTENIDO */

	public traducirContenidos(contenidos, idioma): Contenido[]{
		contenidos.forEach(contenido => {
			contenido = this.traducirContenido(contenido, idioma);
		});

		return contenidos;
	}

	public traducirContenido(contenido: Contenido, idioma: any): any {

		// Cojemos la traduccion del contenido al idioma seleccionado
		const contenidoIdioma = contenido.Idiomas.get(idioma.value);

		// Seteamos los valores de contenidoFormulario con los valores del idioma seleccionado
		contenido.Titulo = contenidoIdioma.Nombre;
		contenido.Descripcion = contenidoIdioma.Descripcion;
		contenido.HtmlDetalle = contenidoIdioma.htmlVisualizableDetalle;
		contenido.AudioTexto = contenidoIdioma.AudioTexto;
		contenido.NombreCorto = contenidoIdioma.NombreCorto;

		const tipologiaIdioma = contenido.TIPOLOGIA_CONTENIDO.IDIOMAS.find( x => x.IDIOMA.Codigo === idioma.value);
		contenido.TIPOLOGIA_CONTENIDO.Nombre = tipologiaIdioma.Nombre;

		contenido.ElementoAsignado
		.forEach(elemento => {

			// { Nombre: elemento.ALA.Nomobre, Tipo: 'ALA', MostrarEdicion: false, ENTIDAD: elemento}
			if (elemento.Tipo === 'ALA') {
				const alaIdioma = elemento.ENTIDAD.ALA.IDIOMAS.find( x => x.IDIOMA.Codigo === idioma.value);
				elemento.Nombre = alaIdioma.Nombre;
			}

			if (elemento.Tipo === 'ESPACIO') {
				const alaIdioma = elemento.ENTIDAD.ESPACIO.IDIOMAS.find( x => x.IDIOMA.Codigo === idioma.value);
				elemento.Nombre = alaIdioma.Nombre;
			}

			if (elemento.Tipo === 'SECCION') {
				if (elemento.ENTIDAD.SECCION.Nombre !== 'Default') {
					const alaIdioma = elemento.ENTIDAD.SECCION.IDIOMAS.find( x => x.IDIOMA.Codigo === idioma.value);
					elemento.Nombre = alaIdioma.Nombre;
				}
				else{
					elemento.Nombre = elemento.ENTIDAD.SECCION.nombre;
				}
			}

			if (elemento.Tipo === 'NIVEL') {
				const alaIdioma = elemento.ENTIDAD.NIVEL.IDIOMAS.find( x => x.IDIOMA.Codigo === idioma.value);
				elemento.Nombre = alaIdioma.Nombre;
			}
		});
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/idioma/idioma.service.ts